import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Mijas"
      slug="mijas"
      poblacion={94320}
      lat={36.5953}
      lng={-4.6371}
      neighborhoodsText="Trabajamos en Mijas Pueblo, Mijas Costa, Las Lagunas, La Cala de Mijas, Calahonda y Riviera del Sol. Atendemos tanto villas como urbanizaciones."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Mijas?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Mijas?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}